import React from 'react';

import ConfirmModal from '../ConfirmModal';

const SubmitReimbursementsForApprovalConfirmation = props => {
  const { t, count, isSubmitting, visible, onConfirm, onCancel } = props;

  return (
    <ConfirmModal
      loading={isSubmitting}
      visible={visible}
      title={t('sureYouWantToResubmitReimbursementForApproval', { count })}
      onOk={onConfirm}
      onCancel={onCancel}
      okText={t('yes')}
      cancelText={t('no')}
    />
  );
};

export default SubmitReimbursementsForApprovalConfirmation;
